import {
  Box,
  Button,
  Card,
  CardContent,
  Paper,
  Typography,
} from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import FormattedMessage from "features/common/TranslatedMessage";
import React from "react";

export default function ClaimantDispute({
  classes,
  dispute,
  onClick,
  disputeStatus,
  claimantName,
  respondentName,
}) {
  return (
    <Box textAlign="center" display="flex" justifyContent="center">
      <Paper className={classes.item}>
        <Card>
          <CardContent>
            <Box display="flex">
              <FiberManualRecordIcon style={{ color: "#6FCF79" }} />
              <Typography variant="body2">{disputeStatus}</Typography>
              <Box flexGrow={1}></Box>
              <Typography variant="body2">
                <FormattedMessage id="dispute.latestCase" />
              </Typography>
            </Box>
            <Box height="1rem"></Box>
            <Typography
              gutterBottom
              variant="body1"
              className={classes.dispute_heading}
            >
              {claimantName} filed a case against {respondentName} on{" "}
              {dispute.created.split("T")[0]}
            </Typography>

            <Box height="1rem"></Box>

            <Typography variant="subtitle1" color="textSecondary" component="p">
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={onClick}
              >
                <FormattedMessage id="buttons.proceed" />
              </Button>
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    </Box>
  );
}
